import { render, staticRenderFns } from "./BuyOrderPrintPage.vue?vue&type=template&id=e84517b0&"
import script from "./BuyOrderPrintPage.vue?vue&type=script&lang=js&"
export * from "./BuyOrderPrintPage.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrderPrintPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports